import { createSelector } from 'reselect'

import * as authSelectors from '../Auth/auth.selectors'
import * as storyLineSelectors from '../StoryLine/storyLine.selectors'

export const getFirebaseSignInData = (state) => state.firebase

export const getGroupId = createSelector([getFirebaseSignInData], (data) => data.groupId)
export const isFinishedSession = createSelector(
  [getFirebaseSignInData],
  (data) => data.finishedSession
)
export const isFinishedTurn = createSelector([getFirebaseSignInData], (data) => data.finishedTurn)
export const getFirebasePath = createSelector(
  [getFirebaseSignInData],
  (data) => data.firebaseDbPath
)
export const getListenerType = createSelector([getFirebaseSignInData], (data) => data.listenerType)
export const getPlayerList = createSelector([getFirebaseSignInData], (data) => data.playerList)
export const getAllPlayersData = createSelector([getFirebaseSignInData], (data) => data.playersData)
export const getConnectedPlayerList = createSelector(
  [getFirebaseSignInData],
  (data) => data.connectedList
)

export const getFederationsInfo = createSelector([getFirebaseSignInData], (data) => {
  return data.federationsInfo
})
export const getFederations = createSelector(
  [getFederationsInfo, storyLineSelectors.getFederationsFlags],
  (data, flags) => {
    if (!data || !data.federations) return null

    const federations = {}
    Object.keys(data.federations).forEach((federationId) => {
      const federation = data.federations[federationId]
      federations[federationId] = { ...federation, flag: flags[federationId] }
    })
    return federations
  }
)

export const getPlayerData = createSelector([getFirebaseSignInData], (data) => {
  return data.userData
})

export const getPlayersRanking = createSelector(
  [getPlayerList, getFederations],
  (playerList, federations) => {
    if (!playerList) return []
    
    return Object.keys(playerList)
      .map((playerKey) => {
        const player = playerList[playerKey]
        const batp = player.playersAttacking ? Object.keys(player.playersAttacking).length : 0

        return {
          ...playerList[playerKey],
          batp: batp,
          federation: federations ? federations[player.federationId] : null,
          licenseId: playerKey,
          settlers: playerList[playerKey].settlers ? playerList[playerKey].settlers : 0,
        }
      })
      .sort((a, b) => {
        return a.settlers < b.settlers ? 1 : a.settlers == b.settlers ? 0 : -1
      })
      .map((d, i) => {
        return { ...d, position: i + 1 }
      })
  }
)

export const getFederationsRanking = createSelector(
  [getPlayersRanking, getFederations],
  (users, federations) => {
    if (!federations || !users) return null

    return Object.keys(federations)
      .map((federationKey) => {
        let points = 0
        let coins = 0
        const filteredUsers = users.filter((user) => {
          if (user.federationId == federationKey) {
            points += user.settlers
            coins += user.coins
            return true
          }
          return false
        })

        points = filteredUsers.length ? points / filteredUsers.length : 0
        coins = filteredUsers.length ? coins / filteredUsers.length : 0
        return { ...federations[federationKey], points, coins }
      })
      .sort((a, b) => {
        return a.points < b.points ? 1 : a.points == b.points ? 0 : -1
      })
      .map((d, i) => {
        return { ...d, position: i + 1 }
      })
  }
)

export const getUserFederation = createSelector(
  [getPlayerList, authSelectors.getUserInfo, getFederationsRanking],
  (players, user, ranking) => {
    const player = players[user.licenseId]
    return ranking ? ranking.find((federation) => federation.name == player.federationId) : null
  }
)

export const getUserFederationPartners = createSelector(
  [getPlayersRanking, getUserFederation],
  (users, federation) => users.filter((user) => user.federationId == federation.name)
)

export const getOwnPlayerID = createSelector([getFirebaseSignInData], (data) => data.uid)

export const getUserData = createSelector(
  [getPlayerList, authSelectors.getUserInfo, getPlayersRanking, getPlayerData, getUserFederation],
  (players, user, ranking, playerData, federation) => {
    if (!players || !user || !ranking || !playerData) return null
    
    let position = 0
    let found = false
    const batd = playerData.playersAttacked ? Object.keys(playerData.playersAttacked).length : 0
    const playersAttacked = playerData.playersAttacked
    const audioDisabled = playerData.audioDisabled
    
    for (const r of ranking) {
      position += 1
      if (r.licenseId == user.licenseId) {
        found = true
        break
      }
    }
    
    return {
      ...players[user.licenseId],
      federation,
      id: user.licenseId,
      position: position,
      batd: batd,
      playersAttacked: playersAttacked,
      audioDisabled: audioDisabled,
    }
  }
)
export const getUserDataShield = createSelector(
  [getPlayerList, authSelectors.getUserInfo],
  (players, user) => {
    return players[user.licenseId]
  }
)

export const getGroupData = createSelector([getFirebaseSignInData], (data) => {
  return data.groupData
})
export const getUserMap = createSelector([getFirebaseSignInData], (data) => {
  return data.userMap
})
export const getSignInData = (state) => state.firebase
export const getEndSessionTime = createSelector(
  [getGroupData],
  ({ endSessionDate }) => endSessionDate
)
export const getStartSessionTime = createSelector(
  [getGroupData],
  ({ startSessionDate }) => startSessionDate
)
export const getEndGameFlag = createSelector([getGroupData], ({ endGame }) => endGame)
export const getObfuscatedRankingFlag = createSelector([getGroupData], ({ ranking }) => ranking)
